/*
 * Copyright (c) 2025.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React from 'react';
import PropTypes from 'prop-types';
import ConditionsComponent from "./ConditionsComponent.jsx";
import TextInput from "../BasicInputs/TextInput.jsx";
import EntityWrapperSmallLabel from "../EntityWrappers/EntityWrapperSmallLabel.jsx";

class TextInputFormComponent extends React.Component {

    constructor(props) {
        super(props);
        this.state = {}

    }


    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return this.state !== nextState || this.props !== nextProps

    }

    render() {
        return (
            <EntityWrapperSmallLabel label={this.props.name} isRequired={this.props.isRequired}
                                     helpText={this.props.helpText}>


                <TextInput
                    value={this.props.value}
                    innerRef={this.props.innerRef}
                    onClick={this.props.onClick}
                    onKeyDown={this.props.onKeyDown}
                    onChange={event => {
                        if (this.props.onChange !== undefined) {
                            this.props.onChange(event)

                        }
                    }}
                    isReadOnly={this.props.isDisabled}
                    placeholder={this.props.placeholder}
                    extend={<> {this.props.allowConditions &&
                        <div>
                            <ConditionsComponent allowConditions={this.props.allowConditions}
                                                 onConditionChange={(data) => this.props.onConditionChange(data)}
                                                 onConditionRemove={() => this.props.onConditionRemove("")}
                                                 condition={this.props.condition}
                                                 standardValuesLooked={false}/></div>

                    }     </>}
                />

            </EntityWrapperSmallLabel>

        )
    };
}

export default TextInputFormComponent;

TextInputFormComponent.propTypes = {
    errorArray: PropTypes.array,
    formSelectionString: PropTypes.string,
    labelWidth: PropTypes.number,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    value: PropTypes.any.isRequired,
    /**
     * Is input disabled
     * @default false
     *
     */
    isDisabled: PropTypes.bool,
    isRequired: PropTypes.bool,
    placeholder: PropTypes.string,
    onConditionChange: PropTypes.func,
    onConditionRemove: PropTypes.func,
    innerRef: PropTypes.any,
    onClick: PropTypes.func,
    helpText: PropTypes.any,
}

TextInputFormComponent.defaultProps = {
    formSelectionString: "",
    placeholder: "---",
    isDisabled: false,
    labelWidth: 120
}